export const usersMapper = (data) =>
  data.users.map((user) => {
    const { firstName, lastName, email, id } = user || {};
    return { name: `${firstName} ${lastName}`, firstName, lastName, email, id };
  });
